/**
 * Environment configuration for FlowLight
 * This file manages API endpoints for different environments
 */

const getApiBaseUrl = () => {
  // Default to localhost for development
  return 'https://api.flowvana.tech';
};

const getApiEndpoints = () => {
  const baseUrl = getApiBaseUrl();
  
  return {
    search: `${baseUrl}/flow/search`,
    flowDetails: `${baseUrl}/flow`
  };
};

export const ENV_CONFIG = {
  apiBaseUrl: getApiBaseUrl(),
  apiEndpoints: getApiEndpoints(),
  isProduction: typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production'
};
